import { BehaviorSubject, Subject } from 'rxjs';

/**
 * @deprecated
 * DON'T USE
 */
export const stateSubject = new BehaviorSubject({});

export const addEpicSubject = new Subject();
export const addReducerSubject = new Subject();

/**
 * @deprecated
 * DON'T USE
 */
export const state$ = stateSubject.asObservable();

export const addEpic$ = addEpicSubject.asObservable();
export const addReducer$ = addReducerSubject.asObservable();
